import { mergeMap, tap, finalize } from 'rxjs/operators';
import { Component, OnInit, ElementRef, AfterContentInit, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { PlycaDataService } from '../../services/plyca.service';
import { ActivatedRoute } from '@angular/router';
import { PaginationDTO } from '../api/PaginationModel';
import { formPlycaComponent } from '../components/forms/formPlyca.component';
import { UserService } from '../user.service';
import { ActionDefinitionDTO, ValidationResultDTO, ClassifiedActionsDTO } from '../api/plyca-dtos-v2';
import { FormAction, FormConfig } from '../components/forms/form.objects';
import { UIService } from '../ui.service';
import { I18nData } from '../api/plyca-dtos';
import { HelpService, HelpType } from '../components/common/help/help.service';
import { WaitLoadingService } from '../components/common/waitLoading/wait-loading.service';
import { HeaderActionsService } from '../components/common/sub-header/header-actions.service';
import { ActionsProcessComponent } from './actions.process.component';
import * as lodash from 'lodash';
import { BaseComponent } from '../components/common/baseComponent/base.component';
import { DialogService, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';


const CREATE_ACTION = 'create';
const UPDATE_ACTION = 'update';

@Component({
  selector: 'actions',
  templateUrl: 'actions.template.html',
  providers: [DialogService, ActionsProcessComponent]
})
export class actionsComponent extends BaseComponent implements AfterContentInit, OnInit, OnDestroy {
  public classifiedActions: Array<ClassifiedActionsDTO>;
  public filteredClassifiedActions: Array<ClassifiedActionsDTO>;
  public visibleActions: Array<ActionDefinitionDTO>;
  loaded = false;
  filterText: string;
  totalFiltered = 0;
  totalActions = 0;
  /*
   * PARAMETROS DE LA PANTALLA
   */
  // tipo de objeto sobre el que ejecutar las acciones (usuario, expediente, documento...)
  objectType: string;
  // identificador del objeto sobre el que ejecutar las acciones
  objectId: string;
  // agrupacion de acciones a utilizar
  actionClasification: string;
  // indica si la pantalla se abre en modo edición
  editMode = true;

  title = '';

  constructor(
    private plycaService: PlycaDataService,
    private userService: UserService,
    public helpService: HelpService,
    private uiService: UIService,
    //    public modal: Modal,
    private route: ActivatedRoute,
    public dialogService: DialogService,
    private headerActionsService: HeaderActionsService,
    private waitService: WaitLoadingService,
    private elem: ElementRef
  ) {
    super();
    //        this.plycaService = ServiceLocator.injector.get(PlycaDataService);

    this.subscribe(this.route.params, (params => {
      console.log('PARAMETROS RECIBIDOS', params);
      this.actionClasification = params.actionClasification;
      this.subscribe(this.route.queryParams, (queryParams => {
        this.objectType = queryParams['objectType'];
        this.objectId = queryParams['objectId'];
        // si no llega el parámetro, cargamos por defecto las acciones del usuario
        if (!this.objectType) {
          //this.objectType = 'USER';
        }

        if (this.objectType === 'USER') {
          this.objectId = this.userService.getUserId();
        }
      }));



      if (this.actionClasification) {


        this.editMode = false;
      }
      console.log(
        '[constructor] Cargando acciones: ',
        this.objectType,
        this.objectId
      );
      this.loadActions();

    }));
  }

  ngOnDestroy() {
    this.uiService = null;

    this.dialogService = null;
    // this.headerActionsService.clearWindowActions(this.windowHash);
    super.ngOnDestroy();
  }

  ngOnInit(): void {
  }

  ngAfterContentInit(): void {

  }

  loadActions() {

    console.log(
      '[loadActions] Cargando acciones: ',
      this.objectType,
      this.objectId
    );
    this.loaded = false;
    this.waitService.startWaiting();
    let excludeClassification = this.actionClasification === 'CLEAR_CACHE' ? null : 'CLEAR_CACHE'

    this.subscribe(
      this.plycaService
        .getObjectActions(
          this.objectType,
          this.objectId,
          this.actionClasification,
          excludeClassification
        )
        .pipe(finalize(() => {
          this.loaded = true;
          this.loadActionsInit();
          this.waitService.cancelWaiting();
        })), ((actions: PaginationDTO<ActionDefinitionDTO>) => {
          if (actions && actions.content) {


            // Ordenamos
            actions.content.sort((a, b) =>
              a.name < b.name
                ? -1
                : a.name > b.name
                  ? 1
                  : 0
            );

            // // Y Clasificamos
            this.classifiedActions = actions.content.reduce((accumulator: Array<ClassifiedActionsDTO>, item) => {
              let description = item.actionClasification.description;
              let clAction = accumulator.find(i => i.classification === description);
              if (!clAction) {
                clAction = new ClassifiedActionsDTO();
                clAction.classification = description;
                accumulator.push(clAction);
              }
              clAction.actions.push(item);
              return accumulator;
            }, []);
            this.visibleActions = actions.content;
            this.totalActions = actions.content.length;
            this.updateFilter();
          } else {
            this.totalActions = 0;
            this.totalFiltered = 0;
          }

        }));
  }



  loadActionsInit() {
    if (this.editMode) {
      this.subscribe(this.helpService.showContextHelpObservable(HelpType.ACTIONS));
      this.headerActionsService.setTaskDescription(this.elem, 'Actions.title', 'fas fa-share', true);

      this.headerActionsService.clearActions();
      this.subscribe(
        this.headerActionsService.addAction(
          'Actions.create',
          'fas fa-plus',
          'btn btn-primary',
          true
        ), (success => {
          this.editAction();
        }));


      this.headerActionsService.addDivider();
      this.subscribe(
        this.headerActionsService.addAction(
          'General.back',
          'fas fa-chevron-left',
          'btn-outline-secondary',
          true
        ), (success => {
          this.uiService.routeBack();
        }));
      this.subscribe(this.helpService.showContextHelpObservable(HelpType.ACTIONS));

    } else if (this.actionClasification) {


      this.subscribe(
        this.headerActionsService.addAction(
          'General.back',
          'fas fa-chevron-left',
          'btn-outline-secondary',
          true
        ), (success => {
          this.uiService.routeBack();
        }));

      this.buildContext();
    }

  }

  public updateFilter() {
    if (!this.filterText) {
      this.filteredClassifiedActions = this.classifiedActions;
      this.totalFiltered = this.totalActions;
      return;
    }
    this.visibleActions = [];
    let actionsAux: Array<ClassifiedActionsDTO> = [];
    let filteredActionsAux = 0;
    let searchText = this.filterText.toLowerCase();
    if (this.classifiedActions) {
      this.classifiedActions.forEach(cl => {
        if (cl && cl.classification && cl.classification.toLowerCase().indexOf(searchText) !== -1) {
          actionsAux.push(cl);
          filteredActionsAux += cl.actions.length;
        } else {
          let filteredActions = cl.actions.filter(act => {
            return ((act.name && act.name.toLowerCase().indexOf(searchText) !== -1) ||
              (act.description && act.description.toLowerCase().indexOf(searchText) !== -1))
          })
          if (filteredActions && filteredActions.length > 0) {
            let clAux = new ClassifiedActionsDTO();
            clAux.classification = cl.classification;
            clAux.actions = filteredActions;
            filteredActionsAux += filteredActions.length;
            actionsAux.push(clAux);

            this.visibleActions.push(...filteredActions);
          }
        }
      }
      );
    }
    this.filteredClassifiedActions = actionsAux;
    this.totalFiltered = filteredActionsAux;
  }

  helpContext(action: ActionDefinitionDTO): void {
    if (action.actionClasification.identifier === 'LOAD_USER<>ACTION_CLASIFICATION') {
      this.subscribe(this.helpService.showContextHelpObservable(HelpType.LOAD_USERS));
    } else {
      this.subscribe(this.helpService.showContextHelpObservable(HelpType.LOAD_USERS));
    }
  }

  execAction(actionDef: ActionDefinitionDTO) {

    let action = actionDef.executableAction;

    let config: DynamicDialogConfig = {
      header: action.name,

      width: '70%',
      styleClass: 'actionStyle',
      style: { overflow: 'hidden' }


    };
    config['action'] = lodash.cloneDeep(action);
    config['paramsDef'] = lodash.cloneDeep(actionDef.parametersDefinition);

    return this.dialogService.open(ActionsProcessComponent, config);

  }

  buildContext() {
    if (this.actionClasification === 'LOAD_USER') {
      this.subscribe(this.helpService.showContextHelpObservable(HelpType.USERS));
      this.headerActionsService.setTaskDescription(this.elem, 'ControlPanel.actions.usersload.title', 'fas fa-share', true);


    } else if (this.actionClasification === 'CLEAR_CACHE') {
      this.subscribe(this.helpService.showContextHelpObservable(HelpType.CACHE));
      this.headerActionsService.setTaskDescription(this.elem, 'ControlPanel.actions.caches.title', 'fas fa-share', true);


    }
  }

  editAction(action?: ActionDefinitionDTO) {
    console.log('Editando action, ', action);
    let actionId = action ? UPDATE_ACTION : CREATE_ACTION;
    if (!action) {
      action = new ActionDefinitionDTO();
    }
    let actions = new Array<FormAction<ActionDefinitionDTO>>();
    actions.push(
      new CreateAction(
        this.plycaService,
        this.uiService,
        action,
        this.loadActions.bind(this),
        this.helpService,
        actionId
      )
    );
    let config: DynamicDialogConfig = {
      header: action.name,
      width: '70%',
      styleClass: 'formEdition'
    };


    let fcfg = new FormConfig(undefined,
      'actionISettings.json',
      action,
      actions,
      true, true
    );

    /*


    config['formConfig'] = new FormConfig(
      this.getFormSettingURL(),
      this.dtoToBean(data),
      actions,
      true,
      true,
      tags != null ? tags : this.getTagsIdentifier()
    );
    */
    fcfg.isModalWindow = true;

    config['formConfig'] = fcfg;
    config['formConfig'].searchTags = HelpType.CREATE_ACTIONS;
    const ref = this.dialogService.open(formPlycaComponent, config);


  }
}

class CreateAction implements FormAction<ActionDefinitionDTO> {
  buttonTextKey = 'General.accept';
  buttonClass = 'btn btn-primary';
  imageClass = 'fas fa-pencil-alt';
  closeOnSuccess = true;
  visibility = true;

  constructor(
    private plycaService: PlycaDataService,
    private uiService: UIService,
    private actionDef: ActionDefinitionDTO,
    private loadActions: Function,
    private helpService: HelpService,
    public actionId: string
  ) {

  }

  executeFormAction(
    model: ActionDefinitionDTO,
    action?: string
  ): Observable<any> {
    if (this.actionDef.parametersDefinition) {
      this.actionDef.parametersDefinition.forEach(p => p['_parent'] = null);
    }
    return this.plycaService.validateUserAction(this.actionDef).pipe(
      mergeMap((response: any) => {
        // let validatioResult = response.json() as ValidationResultDTO;
        let validatioResult = response as ValidationResultDTO;
        if (validatioResult.errors && validatioResult.errors.length > 0) {
          // devolver un HTTP 400 (Bad request) como excepcion
          response.status = 400;
          throw response;
        } else {
          if (this.actionId === CREATE_ACTION) {
            return this.plycaService.createUserAction(this.actionDef).pipe(
              tap(() => {
                this.uiService.showMessage(
                  new I18nData('Actions.created'),
                  new I18nData('General.info')
                );
                this.loadActions();
              })
            );
          } else if (this.actionId === UPDATE_ACTION) {
            return this.plycaService.updateUserAction(this.actionDef).pipe(
              tap(() => {
                this.uiService.showMessage(
                  new I18nData('Actions.updated'),
                  new I18nData('General.info')
                );
              })
            );
          }
        }
      })
    );
  }



}
